const mainHideClass = "hide-this";

const differentFormat = ["HU"];

export const hideDomElement = (domElement) => {
    if (!domElement) return;
    domElement.classList.add(mainHideClass);
}

export const showDomElement = (domElement) => {
    if (!domElement) return;
    domElement.classList.remove(mainHideClass);
}

export const moneyToFloat = (money, fromShopifyValue = false) => {
    let value;
    let valueNoComma;
    switch (Shopify.country) {
        case "HU":
            if(fromShopifyValue){
                valueNoComma = money.replace(".", "");
                value = valueNoComma.match(/[0-9,]+/g);
            }
            else{
                valueNoComma = money.replace(",", "");
                value = valueNoComma.match(/[0-9,]+/g);
            }

            if (value.length) {
                return parseFloat(value[0]);
            }
        case "CZ":
            valueNoComma = money.replace(",", "");
            value = valueNoComma.match(/[0-9,]+/g);
            if (value.length) {
                return parseFloat(value[0]);
            }
        default:
            value = money.match(/[0-9,]+/g);
            if (value.length) {
                return parseFloat(value[0].replace(",", "."));
            }
    }
    return false;
}

export const percentageDiscount = (newValue, oldValue) => {
    return "- " + Math.round(100 * (1 - parseFloat(newValue) / parseFloat(oldValue))) + "%";
}

export const finalPriceFormat = (price) => {
    if (differentFormat.includes(Shopify.country)) {
        switch (Shopify.country) {
            case "HU":
                let removeEverythingAfterDot = price.replace(/\.../g, "").replace(",", ".");
                return removeEverythingAfterDot;
            case "CZ":
                return price;
        }
    } else {
        return price;
    }
}